export default {
      id: "header_facebook-usage",
      viewBox: "0 0 10 20",
      url: "../dist/images/" + "sprite.svg#header_facebook-usage",
      toString: function () {
        return this.url;
      }
    }